import LandingBannerPresentation from 'components/LandingBanner/LandingBannerPresentation'

export default {
  Presentation: LandingBannerPresentation,
}
